import tw, { styled } from "twin.macro";

export const StyledInput = styled.input((isTextarea) => [
  tw`w-full p-5 capitalize text-xl  border-b border-blue-500`,
  isTextarea && tw`normal-case`,
]);
